import { defineMessages } from 'react-intl';

export default defineMessages({
	countryInput: {
		id: 'purchase.billingInfoForm.countryInput',
		defaultMessage: 'Country',
		description: 'Name for input to collect country',
	},
});
